import {
  TopHeader,
  TopHeading,
} from 'modules/Exp-Candidates/Components/DrivePage/style'
import DriveTable from 'modules/Exp-Candidates/Components/DriveTable/index'
import React, { useEffect, useRef, useState } from 'react'

const DrivePage = ({ getDriveListData, setDashboardNavs, dashboardNavs }) => {
  const [currentPage, setCurrentPage] = useState(0)
  const tableRef = useRef(null)
  const [corporateStatus, setCorporateStatus] = useState('')
  const [occurrence, setOccurrence] = useState('UPCOMING')
  const [searchValue, setSearchValue] = useState('')
  const [sortBy, setSortBy] = useState('')

  const [driveRoles, setDriveRoles] = useState([])
  const [driveMode, setDriveMode] = useState([])
  const [driveStatus, setDriveStatus] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [listOfDrivesDetails, setListOfDrivesDetails] = useState({})

  const onPageChange = pageNum => {
    setCurrentPage(pageNum - 1)
    tableRef.current.scrollIntoView({
      behavior: 'smooth',
    })
  }

  const onChangeSort = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }

  useEffect(() => {
    if (dashboardNavs) {
      setOccurrence(dashboardNavs)
    }
    return setDashboardNavs(null)
  }, [])

  const getDariveData = async driveStartDate => {
    setIsLoading(false)
    let response = await getDriveListData({
      currentPage,
      searchValue,
      corporateStatus,
      occurrence: dashboardNavs || occurrence,
      driveRoles,
      driveMode,
      driveStatus,
      sortBy,
      driveStartDate: driveStartDate || '',
    })
    if (response?.status >= 200 && response?.status <= 300) {
      setListOfDrivesDetails(response?.data?.data)
      setIsLoading(true)
    } else {
      setIsLoading(true)
    }
  }

  useEffect(() => {
    if (!dashboardNavs) {
      getDariveData()
    }
  }, [currentPage, searchValue, corporateStatus, occurrence, sortBy])

  return (
    <>
      <TopHeader row spaceBetween alignCenter>
        <TopHeading flexStart column ref={tableRef}>
          Experienced Candidate
        </TopHeading>
      </TopHeader>

      <DriveTable
        listOfDrivesDetails={listOfDrivesDetails}
        onPageChange={onPageChange}
        currentPage={currentPage}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        driveRoles={driveRoles}
        setDriveRoles={setDriveRoles}
        driveMode={driveMode}
        setDriveMode={setDriveMode}
        driveStatus={driveStatus}
        setDrivestatus={setDriveStatus}
        filteApplied={getDariveData}
        isLoading={isLoading}
        corporateStatus={corporateStatus}
        onChangeSort={onChangeSort}
        occurrence={occurrence}
        setCorporateStatus={setCorporateStatus}
      />
    </>
  )
}

export default DrivePage
